<template>
    <div class="cnt_box">

        <!-- 顶部title -->
        <div class="cnt_top_box" :style="{
            'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
            'backgroundColor': '#f5f5f5' // 添加备用背景色
        }">
            <!-- <div class="boxbox_img">
                <img src="../assets/img/ba.png" alt="" class="back" @click="back">
            </div> -->
            <div class="flex">
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <div class="right_top_box">
                    <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                    <!-- <div class="right_top_txt_shu">|</div>
                    <Kefu :sn='data.sn'></Kefu> -->
                </div>
            </div>
            <img class="jindu" v-if="$i18n.locale == 'en'" src="../assets/img/jindutiao2.png" alt="">
            <!-- <img class="jindu" v-else src="../assets/img/jindutiao2_cn.png" alt=""> -->
            <img class="jindu1" v-else src="../assets/img/iscou.png" alt="">
            <div class="cnt_flex">
                <div class="cnt_num_box">
                    <p>{{ carbonFootprint }}</p>
                    <span>kgCO₂e</span>
                </div>
                <div class="cnt_top_title">{{ $t('TotalCarbonFootprint') }}</div>
                <!-- <div class="cnt_top_div"></div> -->
            </div>
        </div>
        <div class="wrap">
            <div class="info">
                <div v-if="config.promiseDisplayed == 1" class="jinT">{{ $t('Pledgetxt') }}</div>
                <ul class="">
                    <li v-if="config.promiseDisplayed == 1 || config.promiseDisplayed == 2">
                        <div style="touch-action: manipulation;width: 100%;">
                            <el-select popper-class="my-select-dropdown" style="width: 100%;margin: 24px 0;border: 1px solid #dcdfe6 !important;" multiple :multiple-limit="3" :teleported="true" v-model="data.plevalue" @change="changeplevalue" @click.native.stop @touchend.native.stop :placeholder="$t('Makepledge')">
                                <el-option :label="$t('ple0')" :value="$t('ple0')"></el-option>
                                <el-option :label="$t('ple01')" :value="$t('ple01')"></el-option>
                                <!-- <el-option :label="$t('ple1')" :value="$t('ple1')"></el-option> -->
                                <el-option :label="$t('ple2')" :value="$t('ple2')"></el-option>
                                <el-option :label="$t('ple3')" :value="$t('ple3')"></el-option>
                                <el-option :label="$t('ple4')" :value="$t('ple4')"></el-option>
                                <el-option :label="$t('ple5')" :value="$t('ple5')"></el-option>
                                <el-option :label="$t('ple6')" :value="$t('ple6')"></el-option>
                                <el-option :label="$t('ple7')" :value="$t('ple7')"></el-option>
                                <el-option :label="$t('ple8')" :value="$t('ple8')"></el-option>
                                <el-option :label="$t('ple9')" :value="$t('ple9')"></el-option>
                                <el-option :label="$t('ple10')" :value="$t('ple10')"></el-option>
                                <el-option :label="$t('ple11')" :value="$t('ple11')"></el-option>
                                <el-option :label="$t('ple12')" :value="$t('ple12')"></el-option>
                                <el-option :label="$t('ple13')" :value="$t('ple13')"></el-option>
                                <el-option :label="$t('ple14')" :value="$t('ple14')"></el-option>
                                <el-option :label="$t('ple15')" :value="$t('ple15')"></el-option>
                                <el-option :label="$t('ple16')" :value="$t('ple16')"></el-option>
                            </el-select>
                        </div>
                    </li>
                    <li v-if="(config.promiseDisplayed == 1 || config.promiseDisplayed == 2) && textareaBoole">
                        <el-input 
                        placeholder="Please enter Pledge"
                        type="textarea" 
                        :placeholder="data.plevalue"
                        :autosize="{ minRows: 4}" 
                        v-model="data.promiseContent" 
                        maxlength="120" 
                        show-word-limit></el-input>
                    </li>
                    <li v-if="config.promiseDisplayed == 2">
                        <div style="touch-action: manipulation;width: 100%;">
                            <el-select popper-class="my-select-dropdown" style="width: 100%;margin: 24px 0;border: 1px solid #dcdfe6 !important;" :teleported="true" v-model="data.teamName" @click.native.stop @touchend.native.stop :placeholder="$t('Pleaseteamname')">
                                <el-option label="带头大哥(AMP01班)" value="A01"></el-option>
                                <el-option label="AMP19班" value="A02"></el-option>
                                <el-option label="黑骑战队(AMP28班)" value="A03"></el-option>
                                <el-option label="AMP34班" value="A04"></el-option>
                                <el-option label="武林鬃狮队（AMP50班）" value="A05"></el-option>
                                <el-option label="AMP61班" value="A06"></el-option>
                                <el-option label="鲲鹏（AMP64）" value="A07"></el-option>
                                <el-option label="AMP67班" value="A08"></el-option>
                                <el-option label="AMP69班" value="A09"></el-option>
                                <el-option label="AMP73班真自在跑团" value="A10"></el-option>
                                <el-option label="骑士74班（AMP74班）" value="A11"></el-option>
                                <el-option label="AMP75班" value="A12"></el-option>
                                <el-option label="AMP76班" value="A13"></el-option>
                                <el-option label="超悦者（AMP78班）" value="A14"></el-option>
                                <el-option label="七九·逐光队（AMP79班）" value="A15"></el-option>
                                <el-option label="八零战队（AMP80班 ）" value="A16"></el-option>
                                <el-option label="81真经队（AMP81班 ）" value="A17"></el-option>
                                <el-option label="AMP83班" value="A18"></el-option>
                                <el-option label="九州队（AMP85班）" value="A19"></el-option>
                                <el-option label="AMP86班" value="A20"></el-option>
                                <el-option label="AMP西南24小时战队" value="A21"></el-option>
                                <el-option label="AMP56&70联合战队" value="A22"></el-option>
                                <el-option label="中欧教工队" value="A23"></el-option>
                                <el-option label="阜康集团逆风前行者" value="B01"></el-option>
                                <el-option label="鼎植VIIV超能战队" value="B02"></el-option>
                                <el-option label="上海细胞队" value="B03"></el-option>
                                <el-option label="瀛跑先锋" value="B04"></el-option>
                                <el-option label="OpenRock 开石（中欧CMO17班）" value="C01"></el-option>
                                <el-option label="合之光队（CMO15&16班）" value="C02"></el-option>
                                <el-option label="旦行千里" value="C03"></el-option>
                                <el-option label="一路生花" value="C04"></el-option>
                                <el-option label="征十一 （中欧EE ）" value="C05"></el-option>
                                <el-option label="南大鹰之队" value="C06"></el-option>
                                <el-option label="赋能者联盟（商学院CHRO8班）" value="C07"></el-option>
                                <el-option label="组委会队伍" value="C08"></el-option>
                                <el-option label="志愿者队伍" value="C09"></el-option>
                                <el-option label="迷你马拉松队伍" value="C10"></el-option>
                                <el-option label="班夫电影节团队" value="C11"></el-option>
                                <el-option label="极地冰川团队" value="C12"></el-option>
                                <el-option label="其他校友与跑友们" value="C13"></el-option>
                            </el-select>
                        </div>
                    </li>
                    <li>
                        <img src="../assets/img/name.png" alt="" class="name" />
                        <el-input :placeholder="$t('NAME')" v-model="data.name"></el-input>
                    </li>
                    
                    <!-- <li>
                        <div class="agrees">Please enter your full name, entered name will reflect in certification</div>
                    </li> -->
                    <li v-if="config.emailDisplayed">
                        <div class="imgs">
                            <img src="../assets/img/youxiang.png" alt="" class="youxiang" />
                        </div>
                        <el-input :placeholder="$t('Email')" v-model="data.email"></el-input>
                    </li>
                </ul>
                <div class="please" v-if="config.emailDisplayed">
                    {{ $t('Pleasevisit') }}
                    <a href="https://www.mvgx.com/" style="color: #7d7f81; text-decoration: none">https://www.mvgx.com/
                    </a>
                    {{ $t('formoreinformationabout') }}
                </div>
            </div>

            

            <div class="agree" v-if="config.promiseDisplayed == 1">
                <el-checkbox v-model="data.check"></el-checkbox>
                <span>{{ $t('checktxt') }}
                     <!-- <a href="https://www.mce.sg/terms-of-use">https://www.mce.sg/terms-of-use.</a> -->
                    </span>
            </div>
            <div class="agree" v-else>
                <el-checkbox v-model="data.check"></el-checkbox>
                <span>{{ $t('Iagreetosharemypersonaldata') }}</span>
            </div>

            <el-button class="btns" @click="submit" v-if="config.promiseDisplayed == 1">{{ $t('Footprintbtn') }}</el-button>
            <el-button class="btns" @click="submit" v-else>{{ $t('Confirm') }}</el-button>
        </div>

        <!-- 校验弹出框 -->
        <el-dialog title="" :visible.sync="dailogDate1" :close-on-click-modal="false" width="95%" :show-close="false"
            center>
            <div>{{ messageData }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_confirm" @click="gotoResult1">{{ $t('Confirm') }}</div>
            </span>
        </el-dialog>
        <!-- 校验弹出框 -->
        <el-dialog title="" :visible.sync="dailogDate" :close-on-click-modal="false" width="95%" :show-close="false"
            center>
            <div>{{ messageData }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_confirm" @click="gotoResult">{{ $t('Confirm') }}</div>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import cnt from "@/api/cnt";
import { Loading } from "element-ui";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            data: {
                name: "",
                plevalue: [],
                teamName: "",
                promiseContent: "",
                email: "",
                sn: "",
                check: false,
            },
            messageData: '',
            textareaBoole: false,
            dailogDate: false,
            dailogDate1: false,
            carbonFootprint: 0,
            detail: {},
            config: '',
        };
    },
    created() {
        this.data.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    mounted() {
        this.data.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        console.log(this.config.emailDisplayed)
        // this.getTravelRecord();
        this.getCarConNum()
        // this.getUserEvent(1,1)
    },
    watch: {},
    methods: {
        back() {
            this.$router.go(-1)
        },
        changeplevalue(value) {
            // 如果不是 "other."，就赋值给 promiseContent
            if(value == 'write my own pledge' ){
                this.textareaBoole = true
                this.data.promiseContent = "";
            }else{
                this.data.promiseContent = value;
                this.textareaBoole = false
            }
        },
        gotoResult() {
            console.log('跳转方法执行了');
            if(this.config.promiseDisplayed == 1){
                this.dailogDate = false
            }else{
                this.$router.push({ path: "/carsuccess" })
            }
        },
        gotoResult1() {
            this.dailogDate1 = false
        },
        //用户行为分析
        getUserEvent(val, type, sum) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
                carbonNeutralizeQuantity: sum ? sum : 0
            }
            cnt.getUserEvent(res => {
                this.$router.push({ path: "/carsuccess" })
                console.log(res)
            }, params)
        },
        //获取碳排放总量
        getCarConNum() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            cnt.getCarConNum(res => {
                console.log(res)
                if (res.code == 200) {
                    this.carbonFootprint = res.data
                }
            }, user.id)
        },
        submit() {
            this.messageData = ''
            if (!this.data.plevalue.length && (this.config.promiseDisplayed == 1 || this.config.promiseDisplayed == 2)) {
                this.messageData = this.$t('Makepledge1')
                this.dailogDate1 = true
                return;
            } else if (!this.data.teamName && this.config.promiseDisplayed == 2) {
                this.messageData = this.$t('Pleaseteamname1')
                this.dailogDate1 = true
                return;
            } else if (!this.data.email && this.config.emailDisplayed) {
                this.messageData = this.$t('Pleaseenteryouremailaddress')
                this.dailogDate1 = true
                return;
            } else if (this.data.email.indexOf("@") == -1 && this.config.emailDisplayed) {
                this.messageData = this.$t('Pleaseenterthecorrectemailaddress')
                this.dailogDate1 = true
                return;
            } else if (!this.data.name) {
                this.messageData = this.$t('Pleaseenteryournametocontinue')
                this.dailogDate1 = true
                return;
            } else if (!this.data.check) {
                this.messageData = this.$t('Pleaseselectthecheckboxtocontinue')
                this.dailogDate1 = true
                return;
            } else {
                let user = JSON.parse(sessionStorage.getItem('user'))
                let data = {
                    username: this.data.name,
                    email: this.data.email,
                    // promiseContent: this.data.promiseContent,
                    promiseContentList:this.data.promiseContent,
                    plevalue: this.data.plevalue,
                    teamName: this.data.teamName,
                    authType: 4,
                    userId: user.id
                };
                let loadingInstance = Loading.service({
                    dangerouslyUseHTMLString: true,
                    text: this.$t('YourCarbonNeutralisationisinProcess'),
                });
                cnt.changePassword((res) => {
                    if (res.code == 200) {
                        this.data.name = "";
                        this.data.email = "";
                        this.data.check = false;
                        this.carconChange(loadingInstance)
                    } else {
                        loadingInstance.close();
                        this.messageData = res.message
                        this.dailogDate = true
                    }
                }, data);
            }
            
        },
        carconChange(loadingInstance) {
            let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                userId: user.id,
                sn: this.data.sn
            }
            cnt.changeneutralize(response => {
                loadingInstance.close();
                if (response.code == 200) {
                    if(this.config.promiseDisplayed == 1 || this.config.promiseDisplayed == 2){
                        this.getUserEvent(2, 5, response.data.giftCardInfo.neutralizeAmount)
                    }else{
                        this.$router.push({
                            path: "/certificate",
                            query: { sn: this.data.sn },
                        });
                    }
                } else {
                    this.messageData = response.message
                    this.dailogDate = true
                }
            }, params)
        }
    },
};
</script>
<style lang="less">
.el-loading-spinner .el-loading-text {
    font-family: Century Gothic;
}
</style>
<style lang="less" scoped>
.jinT{
    font-weight: 600;
    font-size: 24px;
    color: #1E1E1E;
    text-align: center;
}
.cnt_box {
    width: 100%;
    height: 100%;
}

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 50px 20px 0;
}

.cnt_top_box {
    width: 100%;
    // height: 21.1563rem;
    height: 350px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .right_top_box {
        display: flex;
        align-items: center;

        .right_top_txt {
            font-size: 12px;
            font-family: Century Gothic;
            color: #EDFFFE;
        }

        .right_top_txt_shu {
            margin: 0 12px;
            color: #EDFFFE;
        }

        .bangzhu {
            width: 17px;
            height: 17px;
        }
    }

    .boxbox_img {
        position: absolute;
        top: 10px;
        left: 20px;
    }

    .logo {
        width: auto;
    }

    .jindu {
        width: 20.8438rem;
        display: flex;
        justify-content: center;
        margin: 40px auto 0;
    }

    .jindu1{
        width: auto;
        height: 2.5938rem;
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
    }

    .cnt_top_div {
        width: 100%;
        height: 1.6875rem;
        border-radius: 1.25rem 1.25rem 0 0;
        background: #FFFFFF;
        position: absolute;
        bottom: -0.0625rem;
    }

    .cnt_flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 40px;

        .cnt_num_box {
            display: flex;

            p {
                font-size: 3.0625rem;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #FFFFFF;
                line-height: 2.75rem;
            }

            span {
                font-size: .75rem;
                font-family: Century Gothic;
                color: #FFFFFF;
                margin: 1.5rem 0 0 .3125rem;
            }
        }

        .cnt_top_title {
            font-size: .8125rem;
            font-family: Century Gothic;
            color: #FFFFFF;
            margin-top: .2813rem;
        }
    }

}

.wrap {
    background: #ffffff;
    border-radius: 1.25rem 1.25rem 0rem 0rem;
    transform: translateY(-40px);
    padding: 1.6875rem 1.25rem 2.5rem;
    height: auto;

    .info {
        padding: 20px 15px;
        // background: #FFFFFF;
        box-shadow: 0rem 0.125rem 1.5625rem 0rem rgba(15, 95, 75, 0.08);
        border-radius: 1.25rem;

        li {
            list-style: none;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 0.0625rem solid #e6f0f2;

            .name {
                width: 1rem;
                height: 1.0625rem;
            }

            .youxiang {
                width: 1.0625rem;
                height: 0.75rem;
            }
        }

        li:last-child {
            margin-top: 10px;
        }

        li:first-child {
            margin-top: 0rem;
        }
    }

    .please {
        font-size: 0.8125rem;
        font-family: Century Gothic;
        color: #c1c1c1;
        text-align: center;
        margin-top: 1.0625rem;
        line-height: 1.125rem;

        span {
            color: #7d7f81;
        }
    }

    .agrees {
        display: flex;
        font-size: 0.8125rem;
        font-family: Century Gothic;
        color: #8f8f8f;
        line-height: 1.125rem;
    }

    .agree {
        display: flex;
        font-size: 0.8125rem;
        font-family: Century Gothic;
        color: #8f8f8f;
        line-height: 1.125rem;
        margin: 1.25rem 0 3.75rem;
        align-items: flex-start;

        span {
            margin-left: 0.625rem;
            flex: 1;
            pointer-events: none;
            user-select: text;
        }
    }

    .btns {
        width: 100%;
        height: 2.8125rem;
        background: linear-gradient(90deg, #6cb1cc 0%, #59c798 100%);
        box-shadow: 0rem 0.1563rem 0.375rem 0rem rgba(0, 98, 76, 0.22);
        border-radius: 0.625rem;
        font-size: 0.9375rem;
        font-family: Century Gothic;
        color: #ffffff;
    }
}

::v-deep .el-input__inner {
    border: none;
    border-bottom: 0.0625rem solid #e6f0f2;
    color: #303236;
    -webkit-appearance: none;
}

::v-deep ::-webkit-input-placeholder {
    /* WebKit browsers，webkit内核浏览器 */
    color: #8f8f8f;
    font-size: 12px;
}

::v-deep :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #8f8f8f;
    font-size: 12px;
}

::v-deep ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #8f8f8f;
    font-size: 12px;
}

::v-deep :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #8f8f8f;
    font-size: 12px;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #68b4c6;
    border-color: #68b4c6;
}

/* 限制 checkbox 点击区域，只允许 checkbox 本身可点击 */
::v-deep .agree .el-checkbox {
    margin-right: 0;
}

::v-deep .agree .el-checkbox__label {
    display: none;
    padding-left: 0;
    width: 0;
}

/* 限制整个 checkbox 组件的点击区域，只有 input 部分可点击 */
::v-deep .agree .el-checkbox > span {
    pointer-events: none;
}

::v-deep .agree .el-checkbox__input {
    cursor: pointer;
    pointer-events: auto;
}

::v-deep .el-dialog {
    background: #FFFFFF;
    border-radius: 20px;
    margin-top: 30vh !important;

    .el-dialog__title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;
    }

    .el-dialog__body {
        font-size: 15px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 20px;
        text-align: center;
        padding: 1.5625rem .875rem 1.875rem !important;
    }

    .dialog-footer {
        display: flex;
        justify-content: center;

        .btn_cancel {
            width: 131px;
            height: 45px;
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid;
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 10px;
        }

        .btn_confirm {
            width: 131px;
            height: 47px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 10px;
        }
    }
}

.back {
    width: .8125rem;
    height: 1.375rem;
    // margin: 2.5rem 1.25rem 0;
}

input::-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #303236; //设置填充字体颜色
}

input:-webkit-autofill {
    background-color: #fff; //设置成元素原本的颜色
    background-image: none;
    color: #303236;
}

::v-deep .el-loading-spinner .el-loading-text {
    font-family: Century Gothic !important;
}


::v-deep .my-select-dropdown {
  max-width: 100vw;
  .el-select-dropdown__item {
    white-space: normal;
    word-break: break-word;
  }
}


</style>